import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import SupportChat from "@/components/SupportChat";
import Navbar from "@/components/Navbar";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Browse from "@/pages/Browse";
import BusinessDetail from "@/pages/BusinessDetail";
import PostJob from "@/pages/PostJob";
import ForBusinesses from "@/pages/ForBusinesses";
import Fees from "@/pages/Fees";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import ClientDashboard from "@/pages/ClientDashboard";
import JobDetail from "@/pages/JobDetail";
import BusinessDashboard from "@/pages/BusinessDashboard";
import AdminConsole from "@/pages/AdminConsole";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Messages from "@/pages/Messages";

function Shell({ children }) {
  return <><Navbar />{children}</>;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

const CLIENT_ONLY = ["client"];
const BUSINESS_ONLY = ["business"];
const ADMIN_ONLY = ["admin"];

function AppRouter() {
  const location = useLocation();
  // Process OAuth callback FIRST, synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route path="/" element={<Shell><Landing /></Shell>} />
      <Route path="/login" element={<Login />} />
      <Route path="/browse" element={<Shell><Browse /></Shell>} />
      <Route path="/business/:id" element={<Shell><BusinessDetail /></Shell>} />
      <Route path="/post-job" element={<Shell><PostJob /></Shell>} />
      <Route path="/for-businesses" element={<Shell><ForBusinesses /></Shell>} />
      <Route path="/fees" element={<Shell><Fees /></Shell>} />
      <Route path="/terms" element={<Shell><Terms /></Shell>} />
      <Route path="/privacy" element={<Shell><Privacy /></Shell>} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/dashboard" element={<ProtectedRoute roles={CLIENT_ONLY}><Shell><ClientDashboard /></Shell></ProtectedRoute>} />
      <Route path="/jobs/:id" element={<ProtectedRoute><Shell><JobDetail /></Shell></ProtectedRoute>} />
      <Route path="/business" element={<ProtectedRoute roles={BUSINESS_ONLY}><Shell><BusinessDashboard /></Shell></ProtectedRoute>} />
      <Route path="/messages" element={<ProtectedRoute><Shell><Messages /></Shell></ProtectedRoute>} />
      <Route path="/messages/:id" element={<ProtectedRoute><Shell><Messages /></Shell></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute roles={ADMIN_ONLY}><Shell><AdminConsole /></Shell></ProtectedRoute>} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
          <SupportChat />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
